import styled from 'styled-components';

export const StyledFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: ${props => props.theme.spacing(2, 5)};
  background-color: ${props => props.theme.colors.neutral.lightBone};
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
`;
